import { render } from "./PartnerCard.vue?vue&type=template&id=710411c8&scoped=true"
import script from "./PartnerCard.vue?vue&type=script&lang=js"
export * from "./PartnerCard.vue?vue&type=script&lang=js"

import "./PartnerCard.vue?vue&type=style&index=0&id=710411c8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710411c8"]])

export default __exports__